
import {
  SpeechConfig,
  AudioConfig,
  SpeechRecognizer,
  ResultReason,
} from "microsoft-cognitiveservices-speech-sdk";
import BaseAsr from "../baseAsr";
import { logAzureAsr } from "../../speech-service-log/log";

/**
 * reference: @see {@link https://learn.microsoft.com/zh-tw/azure/cognitive-services/speech-service/how-to-recognize-speech?pivots=programming-language-javascript}
 */
export default class AzureAsr extends BaseAsr {
  /**
   * @type {SpeechConfig}
   * @protected
   */
  _speechConfig;

  /**
   * @type {AudioConfig}
   * @protected
   */
  _audioConfig;

  /**
   * @type {SpeechRecognizer}
   * @protected
   */
  _recognizer;

  _sourceLang;

  constructor(authorizationToken, region, sourceLang) {
    super();
    this._speechConfig = SpeechConfig.fromAuthorizationToken(authorizationToken, region);

    this._sourceLang = sourceLang;
    this._speechConfig.speechRecognitionLanguage = this._sourceLang;
    this._audioConfig = AudioConfig.fromDefaultMicrophoneInput();
    this._recognizer = new SpeechRecognizer(
      this._speechConfig,
      this._audioConfig
    );

    this._recognizer.recognizing = (s, e) => {
        logAzureAsr(e.result);
        this.emit("recognizing", e.result?.text);
    }

    this._recognizer.recognized = (s, e) => {
        logAzureAsr(e.result);
      switch (e.result.reason) {
        case ResultReason.RecognizedSpeech:
          this.emit("recognized", e.result?.text);
          break;
      }
    };
  }

  start() {
    this._recognizer.startContinuousRecognitionAsync();
  }

  stop() {
    this._recognizer.stopContinuousRecognitionAsync();
    try{
        this._recognizer.close();
    }catch(err){
        //
    }
  }

  static fromToken(token, sourceLang){
    const { region } = JSON.parse(atob(token.split(".")[1]));
    return new AzureAsr(
        token,
        region,
        sourceLang
    );
  }
}
